/** Duplicar una campaña de envío masivo: mismos textos, conexión, lista, intervalos y recurrencia, sin fecha ni estado. */
const COPY_FIELDS = [
  "message1", "message2", "message3", "message4", "message5",
  "confirmationMessage1", "confirmationMessage2", "confirmationMessage3", "confirmationMessage4", "confirmationMessage5",
  "confirmation", "whatsappId", "contactListId", "tagListId", "fileListId", "tipo", "isRecurring",
  "recurrenceType", "recurrenceInterval", "recurrenceDaysOfWeek", "recurrenceDayOfMonth", "recurrenceEndDate", "maxExecutions",
  "messageInterval", "longerIntervalAfter", "greaterInterval", "autoTagEnabled", "autoTagId", "promptId", "replyPromptId",
  "includeColdContacts", "telegramButtons", "pollEnabled", "pollMode", "pollQuestion", "pollOptions", "pollSelectableCount",
];
const NULLABLE = new Set(["autoTagId"]);

export function buildCampaignCopy(data) {
  const out = { name: `${data?.name || "Campaña"} - Copia` };
  for (const key of COPY_FIELDS) {
    if (!data || !(key in data)) continue;
    const value = data[key];
    out[key] = value === null || value === undefined ? (NULLABLE.has(key) ? null : "") : value;
  }
  out.tipo = data?.tipo || (data?.isRecurring ? "RECURRENTE" : "UNICA");
  out.isRecurring = out.tipo === "RECURRENTE" || !!data?.isRecurring;
  // La fecha y el estado no se copian: la copia se programa de nuevo.
  out.scheduledAt = "";
  out.status = "INATIVA";
  return out;
}

/** Imagen o archivo de la campaña original como File, para adjuntarlo a la copia. */
export async function campaignMediaFile(baseUrl, data, fetcher = fetch) {
  const path = String(data?.mediaPath || "").trim();
  if (!path) return null;
  const url = /^https?:\/\//i.test(path) ? path : `${String(baseUrl || "").replace(/\/$/, "")}/public/${path.split("/").map(encodeURIComponent).join("/")}`;
  const res = await fetcher(url);
  if (!res.ok) throw new Error(`No se pudo descargar el archivo (${res.status})`);
  const blob = await res.blob();
  const name = data.mediaName || path.split("/").pop();
  return new File([blob], name, { type: blob.type || "application/octet-stream" });
}
